export const Finance = {
  Name: "Фінанси",
  Emoji: "💰",
};
